import { render, staticRenderFns } from "./BoardBaseList.vue?vue&type=template&id=7297db9d&scoped=true"
import script from "./BoardBaseList.vue?vue&type=script&lang=js"
export * from "./BoardBaseList.vue?vue&type=script&lang=js"
import style0 from "./BoardBaseList.vue?vue&type=style&index=0&id=7297db9d&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7297db9d",
  null
  
)

export default component.exports